/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { changeDateMonth } from "../../../utils/Calendar";
import { ChevronDownIcon } from "../Icons/ChevronDownIcon";

import DatePickerSelectorModule from "./DatePickerSelector.module.css";

export interface DatePickerSelectorProps {
  shownDate: Date;
  currentDate: Date;
  setShownDate: React.Dispatch<React.SetStateAction<Date>>;
}

export const DatePickerSelector: React.FC<DatePickerSelectorProps> = ({
  shownDate,
  currentDate,
  setShownDate,
}: DatePickerSelectorProps) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const shownDateTime = new Date(shownDate.getFullYear(), shownDate.getMonth()).getTime();
  const currentDateTime = new Date(currentDate.getFullYear(), currentDate.getMonth()).getTime();

  const isBackEnabled = shownDateTime > currentDateTime;

  const handleIconClick = (isNextMonth: boolean) => {
    return () => {
      if (shownDateTime >= currentDateTime) {
        if (!(shownDateTime === currentDateTime && !isNextMonth)) {
          setShownDate(changeDateMonth(shownDate, isNextMonth));
        }
      }
    };
  };

  return (
    <div className={DatePickerSelectorModule.DatePickerSelector}>
      <div
        className={`${DatePickerSelectorModule.DatePickerSelectorIcon} ${DatePickerSelectorModule.DatePickerSelectorIconLeft}`}
        onClick={handleIconClick(false)}
      >
        <ChevronDownIcon isBackEnabled={isBackEnabled} />
      </div>

      <div className={DatePickerSelectorModule.DatePickerSelectorDate}>
        {" "}
        {`${months[shownDate.getMonth()]} ${shownDate.getFullYear().toString()}`}
      </div>

      <div
        className={`${DatePickerSelectorModule.DatePickerSelectorIcon} ${DatePickerSelectorModule.DatePickerSelectorIconRight}`}
        onClick={handleIconClick(true)}
      >
        <ChevronDownIcon isBackEnabled />
      </div>
    </div>
  );
};
